export const DollarProcessIcon = ({
  strokeColor = "var(--color-blue)",
  ...props
}: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g id="Icons All">
      <path
        id="Vector"
        d="M8 14.6673C11.6819 14.6673 14.6667 11.6826 14.6667 8.00065C14.6667 4.31875 11.6819 1.33398 8 1.33398"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M8.00016 14.6673C4.31826 14.6673 1.3335 11.6826 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="1 3"
      />
      <path
        id="Vector_3"
        d="M8 4.33398V11.6673"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M9.8335 5C9.8335 5 8.16193 5 7.3335 5C6.50506 5 5.8335 5.67157 5.8335 6.5C5.8335 7.32843 6.50506 8 7.3335 8"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M6.1665 11C6.1665 11 7.83807 11 8.6665 11C9.49494 11 10.1665 10.3284 10.1665 9.5C10.1665 8.67157 9.49494 8 8.6665 8H7.33317"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
